module.exports = __webpack_public_path__ + "img/curate-logo-text.688fce2a.svg";